import React from 'react';
import { Pane, Text } from 'evergreen-ui';
import Progress from './Progress';

/**
 * A reusable progress bar component for the CSV import system
 *
 * @param {Object} props - Component props
 * @param {number} props.value - Current progress value (0-100)
 * @param {string} props.label - Label to display above the progress bar
 * @param {string} props.description - Optional description to display below the progress bar
 * @param {string} props.status - Status text to display next to the progress value
 * @param {boolean} props.isIndeterminate - Whether the progress bar should be indeterminate
 * @param {Object} props.containerProps - Additional props for the container Pane
 */
const ProgressBar = ({
  value = 0,
  label,
  description,
  status,
  isIndeterminate = false,
  containerProps = {},
}) => {
  return (
    <Pane {...containerProps}>
      {label && (
        <Pane display="flex" justifyContent="space-between" marginBottom={4}>
          <Text size={300} fontWeight={500}>
            {label}
          </Text>
          {!isIndeterminate && (
            <Text size={300}>
              {Math.round(value)}% {status && `• ${status}`}
            </Text>
          )}
        </Pane>
      )}
      <Progress
        value={isIndeterminate ? null : value / 100}
        marginY={8}
        width="100%"
      />
      {description && (
        <Text size={300} color="muted">
          {description}
        </Text>
      )}
    </Pane>
  );
};

export default ProgressBar;
